export default {
  addressBook: {
    cancel: 'Cancel',
    row: {
      actions: {
        change: 'Change',
      },
    },
    listView: {
      header: 'Choose Shipping Address',
      submit: 'Use Address',
    },
    createView: {
      header: 'Add a New Shipping Address',
      submit: 'Save & Use Address',
    },
    editView: {
      header: 'Edit Shipping Address',
      submit: 'Save & Use Address',
    },
  },
  shippingAddress: 'Shipping Address',
  taxLabel: {
    callout: 'Estimated Tax*',
    estimated: 'Estimated Tax',
    default: 'Tax',
    tooltip: {
      usaBody: "Most states now collect tax on online purchases. This includes both new and used items. These are not taxes imposed by Reverb – they're the result of legislation enacted by each individual state.",
      internationalBody: "Online purchases are subject to tax. This includes both new and used items. These are not taxes imposed by Reverb – they're the result of regulations enacted by the taxing authorities.",
      learnMore: 'Learn More'
    }
  },
  taxNotification: {
    heading: "*What's with the tax?",
    subheading: "Online purchases are subject to tax. This includes both new and used items.",
    usaBody: "These are not taxes imposed by Reverb – they're the result of legislation enacted by each individual state.",
    internationalBody: "These are not taxes imposed by Reverb – they're the result of regulations enacted by the taxing authorities.",
    learnMore: 'Learn More'
  },
  cart: {
    startCheckout: 'Proceed to Checkout'
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/translations/checkout/en.js